import { DropdownItem, TrashIcon } from 'ui-components';
import { ICreator } from '~/types';

interface RemoveFromListDropdownItemProps {
  creator: ICreator;
  onRemoveFromList?: (creator: ICreator) => void | Promise<void>;
}

export const RemoveFromListDropdownItem: React.FC<
  RemoveFromListDropdownItemProps
> = ({ creator, onRemoveFromList }) => {
  if (!onRemoveFromList) return null;

  return (
    <DropdownItem
      aria-label="Remove from list"
      onClick={() => onRemoveFromList(creator)}
      trackId="foam-lists-talent-remove-from-list"
    >
      <TrashIcon boxSize={4} />
      Remove from list
    </DropdownItem>
  );
};
